import Media from './media';
import Button from './button';
import Richtext from './richtext';

type Article = {
  id: string;
  description?: Richtext;
  date: string;
  icon?: Media;
};

export class FeaturedArticles {
  articles: Article[];
  backgroundColor: string;
  backgroundTexture?: Media;
  contentColor: string;
  cursor?: Button;
  dateColor: string;
  iconColor: string;
  sliderDelay: number;
  timerColor: string;

  constructor(props: any) {
    this.backgroundColor = props.backgroundColor;
    this.backgroundTexture = props.backgroundTexture
      ? new Media(props.backgroundTexture)
      : undefined;
    this.contentColor = props.contentColor;
    this.cursor = props.cursor ? new Button(props.cursor) : undefined;
    this.dateColor = props.dateColor;
    this.iconColor = props.titleColor;
    this.sliderDelay = props.sliderDelayInSeconds
      ? props.sliderDelayInSeconds * 1000
      : 5000;
    this.timerColor = props.timerColor;
    this.articles =
      props.articlesCollection &&
      props.articlesCollection.items.map((article: any, index: number) => ({
        id:
          article.sys && article.sys.id
            ? `${article.sys.id}-${index}`
            : `feature-article-${index}`,
        description: article.description
          ? new Richtext(article.description)
          : undefined,
        date: article.date,
        icon: article.icon ? new Media(article.icon) : undefined
      }));
  }
}

export default FeaturedArticles;
